import api from './index';

export const userAPI = {
  getUserInfo: () => {
    return api.get('/api/user/info');
  },
  updateUserInfo: (data) => {
    return api.put('/api/user/info', data);
  },
  updateAvatar: (formData) => {
    return api.post('/api/user/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getStudyRecords: () => {
    return api.get('/api/user/study-records');
  }
};